import { useEffect, useRef } from "react";

/** Focuses the confirm button on open and, if closing dropped focus, gives it back to the trigger once it can take it. */
export function useConfirmFocus(open: boolean) {
  const trigger = useRef<HTMLButtonElement>(null);
  const confirm = useRef<HTMLButtonElement>(null);
  const wasOpen = useRef(false);
  const owed = useRef(false);
  useEffect(() => {
    if (open) confirm.current?.focus();
    owed.current = !open && wasOpen.current;
    wasOpen.current = open;
  }, [open]);
  // Every render: the trigger may still be disabled or swapped (Deactivate -> Reactivate) when the confirm closes.
  useEffect(() => {
    if (!owed.current) return;
    if (document.activeElement && document.activeElement !== document.body) owed.current = false;
    else if (trigger.current && !trigger.current.disabled) {
      trigger.current.focus();
      owed.current = false;
    }
  });
  return { trigger, confirm };
}
